import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Card, Grid, Button, Dropdown} from 'semantic-ui-react';

class SpecialPartsListHeader extends Component {
  parsePartno(partNoList = []) {
    return partNoList.map((partno) => ({'text': partno, 'value': partno}));
  }
  
  render() {
    const {loadingPartNoList, partNoList, filterName, changeValue, searchClick, handleClearClick, value} = this.props;
    return (
      <Card raised fluid>
        <Grid.Row>
          <div className='title-bar'>
            <div className='title'>
              <h2>Mantenimiento de productos especiales</h2>
              <div className='title-bar-actions'>
                <Button primary
                  as={Link}
                  to='/partes-especiales/nuevo'
                >
                  Agregar
                </Button>
              </div>
            </div>
          </div>
        </Grid.Row>

        <Grid.Row>
          <div className='title-bar'>
            <div className='title'>
              <h4>Código de repuesto</h4>
              <Dropdown selection fluid
                options={this.parsePartno(partNoList)}
                loading={loadingPartNoList}
                name={filterName}
                onChange={changeValue}
                value={value}
              />
              <div className='title-bar-actions'>
                <Button secondary
                  onClick={handleClearClick}
                >
                  Limpiar
                </Button>

                <Button primary
                  onClick={searchClick}
                >
                  Buscar
                </Button>
              </div>
            </div>
          </div>
        </Grid.Row>
      </Card>
    );
  }
}

export default SpecialPartsListHeader;
